export const CATEGORY_PAGES = {
  pipesRo: {
    path: "/pipes-ro",
    eyebrow: "Plumbing & Water Solutions",
    headline: ["Pipes, Fittings &", "Pure Water."],
    accentLine: 1,
    intro:
      "Concealed plumbing decides whether a beautiful bathroom stays beautiful. We stock India's most trusted pipe systems and water-purification brands — with the same genuine billing and installation coordination as our bath fittings.",
    seo: {
      title: "Astral & Fusion Pipes, Kent RO, Zero B in Faridabad — SRK Bath and Tiles",
      description:
        "Buy Astral CPVC pipes, Fusion PPR pipes, Kent RO purifiers and Zero B water softeners in Sector 86, Greater Faridabad. Genuine stock, project pricing, plumber coordination.",
    },
    seoContent: [
      "Looking for Astral pipes in Faridabad or a Kent RO dealer near Sector 86? Shri Radhey Krishna Bath and Tiles stocks complete plumbing and water-care lines alongside its bath fittings — so your contractor gets everything from one counter with one GST invoice.",
      "Our floor carries Astral's CPVC, uPVC and SWR systems, Fusion's CPVC Pro and PPR range with water tanks, Kent RO + UV purifiers and Zero B water softeners. Architects and developers get BOQ-wise pricing and scheduled site delivery across Greater Faridabad.",
    ],
    groups: [
      {
        title: "Pipes & Fittings",
        brands: [
          { name: "Astral Pipes", logo: "https://www.astralltd.com/wp-content/uploads/2022/11/logo.png", line: "CPVC, uPVC, SWR systems, solvent cements and water tanks — India's most specified plumbing brand" },
          { name: "Fusion Pipes", logo: "https://www.fusionpipes.com/main-images/logo/logo-main.png", line: "CPVC Pro, PPR and SWR pipes & fittings manufactured to IS standards, plus storage tanks" },
        ],
      },
      {
        title: "RO & Water Care",
        brands: [
          { name: "Kent RO", logo: "https://www.kent.co.in/cdn/shop/files/kent-logo-hop.svg", line: "RO + UV + UF purifiers for kitchen and whole-home drinking water" },
          { name: "Zero B", logo: "/logos/zerob.svg", line: "RO purifiers, water softeners and conditioning systems — essential for Faridabad's hard water" },
        ],
      },
    ],
    chips: ["CPVC Pipes", "PPR Pipes", "uPVC & SWR", "Pipe Fittings", "Water Tanks", "RO Purifiers", "Water Softeners", "Plumber Coordination"],
  },
  tileAdhesives: {
    path: "/tile-adhesives",
    eyebrow: "Tile Installation Materials",
    headline: ["Adhesives, Grouts &", "Lasting Tile Work."],
    accentLine: 1,
    intro:
      "A tile is only as good as what's under it. We stock India's leading adhesives, epoxy grouts and waterproofing systems — and we'll tell you exactly which grade your tile size and surface needs.",
    seo: {
      title: "Tile Adhesives & Grouts in Faridabad | Laticrete, Roff, Dr. Fixit — SRK Bath and Tiles",
      description:
        "MYK Laticrete, Roff, Dr. Fixit and Ardex Endura tile adhesives, epoxy grouts and waterproofing in Sector 86, Greater Faridabad. Right-grade guidance for 600×1200 slabs and more.",
    },
    seoContent: [
      "For tile adhesive in Faridabad, Shri Radhey Krishna Bath and Tiles stocks the brands professionals ask for: MYK Laticrete, Roff by Pidilite, Dr. Fixit waterproofing and Ardex Endura — adhesives, epoxy grouts, primers and sealants under one roof.",
      "Large-format 600×1200 tiles need C2TE-grade adhesives and epoxy grouts to stay put for decades. Tell us your tile size, surface and area — we'll specify the right product and quantity, and coordinate with your tile contractor for correct application.",
    ],
    groups: [
      {
        title: "Adhesives, Grouts & Waterproofing",
        brands: [
          { name: "MYK Laticrete", logo: "https://cdn-global.laticrete.com/-/media/project/laticrete-international/shared/images/home/image-link-list/laticrete-logo_4c.svg?iar=0&w=440&rev=2223944ddc6347ebb6b05108ac88cdae&hash=582514974229F8E6C01CC1F45B85EDB1", line: "The global benchmark for large-format tile adhesives and epoxy grouts" },
          { name: "Roff by Pidilite", logo: "https://www.roff.in/wp-content/uploads/2020/12/Roff-header-logo-3D.png.webp", line: "Tile adhesives, grouts and stone care from the house of Pidilite" },
          { name: "Dr. Fixit", logo: null, line: "India's most trusted waterproofing — terraces, bathrooms and water tanks" },
          { name: "Ardex Endura", logo: "https://www.ardexendura.com/site/templates/assets/images/Logo.svg", line: "High-performance adhesives trusted for airports, malls and premium homes" },
        ],
      },
    ],
    chips: ["C2TE Tile Adhesives", "Epoxy Grouts", "Waterproofing", "Surface Primers", "Sealants", "Tile Spacers & Tools", "Right-Grade Guidance", "Contractor Coordination"],
  },
};
